// eslint-disable-next-line import/no-extraneous-dependencies
import React from 'react'
import {
    SAVANT_GREEN,
    SEARCH_PLAYER_COMPONENT_WIDTH,
    SEARCH_PLAYER_COMPONENT_HEIGHT,
} from './utils/constants.ts'
import { CompToolPlayer } from './utils/types.ts'

type PlayerSearchSelectedCardProps = {
    player: CompToolPlayer
    uniqueId: string
}

function PlayerSearchSelectedCard(props: PlayerSearchSelectedCardProps) {
    const { player, uniqueId } = props
    const [id, year] = uniqueId.split('-')
    const imageSize = 40

    return (
        <>
            <rect
                x={0}
                y={0}
                width={SEARCH_PLAYER_COMPONENT_WIDTH}
                height={SEARCH_PLAYER_COMPONENT_HEIGHT}
                rx={5}
                stroke={SAVANT_GREEN}
                fill={SAVANT_GREEN}
            />
            <image
                href={`https://midfield.mlbstatic.com/v1/people/${id}/spots/${
                    imageSize * 3
                }`}
                height={imageSize}
                width={imageSize}
                x={SEARCH_PLAYER_COMPONENT_WIDTH / 2 - imageSize / 2}
                y={7}
            />
            <text
                className="player-search-card-text"
                x={SEARCH_PLAYER_COMPONENT_WIDTH / 2}
                y={52}
                textLength={
                    player.name.split(',')[0].length > 13
                        ? SEARCH_PLAYER_COMPONENT_WIDTH - 4
                        : undefined
                }
            >
                {player.name.split(',')[0]}
            </text>
            <text
                className="player-search-card-text player-search-card-year"
                x={SEARCH_PLAYER_COMPONENT_WIDTH / 2}
                y={67}
            >
                {year}
            </text>
        </>
    )
}

export default PlayerSearchSelectedCard
